import NoGoalsCard from "./NoGoalsCard";
import ProgressCard from "./ProgressCard";
import { Parameter } from "./types/goal-parameters";

interface GoalsViewProps {
  parameters?: Parameter[];
}

const GoalProgress = ({ parameters }: GoalsViewProps) => {
  if (!parameters) {
    return (
      <div>
        <div className="w-full md:max-w-[60%] mx-auto flex items-center h-[60dvh]">
          <NoGoalsCard />
        </div>
      </div>
    );
  }

  return (
    <div className="">
      {/* Parameter Progress */}
      <div className="grid lg:grid-cols-2 gap-6">
        {parameters.map((param, index) => {
          const progress =
            param.target > 0
              ? Math.round((param.achieved / param.target) * 100)
              : 0;
          return (
            <ProgressCard
              key={param.name}
              param={param}
              progress={progress}
              index={index}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GoalProgress